import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Home from "./Pages/Home";
import Layout from "./utlis/Layout";
import EventInner from "./Pages/EventInner";
import GalleryInner from "./Pages/GalleryInner";
import MessageInner from "./Pages/MessageInner";
import FounderInner from "./Pages/FounderInner";
import ChairmanMessage from "./Pages/ChairmanMessage";
import HeadmistressMessage from "./Pages/HeadmistressMessage";
import TopperInnerXII from "./Pages/TopperInnerXII";
import TopperInnerX from "./Pages/TopperInnerX";
import SubGallery from "./Pages/SubGallery";
import Schooltiming from "./Pages/Schooltiming";
import Schoolsong from "./Pages/Schoolsong";
import Aboutus from "./Pages/Aboutus";
import Contactus from "./Pages/Contactus";
import DownloadApp from "./Pages/DownloadApp";
import Chemistrylab from "./Pages/Chemistrylab";
import Schoolchoir from "./Pages/Schoolchoir";
import Biologylab from "./Pages/Biologylab";
import SchoolHall from "./Pages/SchoolHall";
import Library from "./Pages/Library";
import Admission from "./Pages/Admission";
import Sports from "./Pages/Sports";
import AIRoboticslab from "./Pages/AIRoboticslab";
import Infirmary from "./Pages/Infirmary";
import Staff from "./Pages/Staff";
import Physicslab from "./Pages/Physicslab";
import Computerlab from "./Pages/Computerlab";
import SubjectsOffered from "./Pages/SubjectsOffered";
import FormerHeadmistress from "./Pages/FormerHeadmistress";
import BoardMembers from "./Pages/BoardMembers";
function App() {
  const router = createBrowserRouter([
    {
      path: "/",
      element: <Layout />,
      children: [
        { index: true, element: <Home /> },
        { path: "events", element: <EventInner /> },
        { path: "gallery", element: <GalleryInner /> },
        { path: "founder-inner", element: <FounderInner /> },
        { path: "chairman-message", element: <ChairmanMessage /> },
        { path: "headmistress-message", element: <HeadmistressMessage /> },
        { path: "message/:category", element: <MessageInner /> },
        { path: "topper-XII", element: <TopperInnerXII /> },
        { path: "topper-X", element: <TopperInnerX /> },
        { path: "school-timing", element: <Schooltiming /> },
        { path: "school-song", element: <Schoolsong /> },
        { path: "about-us", element: <Aboutus /> },
        { path: "admission", element: <Admission /> },
        { path: "contact-us", element: <Contactus /> },
        { path: "computer-lab", element: <Computerlab /> },
        { path: "physics-lab", element: <Physicslab /> },
        { path: "chemistry-lab", element: <Chemistrylab /> },
        { path: "biology-lab", element: <Biologylab /> },
        { path: "library", element: <Library /> },
        { path: "school-choir", element: <Schoolchoir /> },
        { path: "school-hall", element: <SchoolHall /> },
        { path: "sports", element: <Sports /> },
        { path: "staff", element: <Staff /> },
        { path: "ai-robotics-lab", element: <AIRoboticslab /> },
        { path: "infirmary", element: <Infirmary /> },
        { path: "subjects-offered", element: <SubjectsOffered /> },
        { path: "download-app", element: <DownloadApp /> },
        { path: "sub-gallery", element: <SubGallery /> },
        { path: "sub-gallery/:_id", element: <SubGallery /> },
        { path: "former-headmistress", element: <FormerHeadmistress /> },
        { path: "BoardMembers", element: <BoardMembers /> },
      ],
    },
  ]);

  return <RouterProvider router={router} />;
}

export default App;
